import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import DropdownFilter from "../Components/DropdownFilter";

function BalanceFluctuation({ data }) {
  const [filter, setFilter] = useState({
    name: "Overall",
    value: "overall_summary",
  });
  const [graphData, setGraphData] = useState([]);
  const [badgeData, setBadgeData] = useState([]);
  const repeatArray = [1, 2, 3, 4, 5, 6, 7];
  // const graphData = [
  //   [1327359600000, 30.95],
  //   [1327359600001, 56.95],
  //   [1327389600002, 12.95],
  // ];
  const mapData = (data) => {
    const array = data.map((item) => {
      // Combine the date and time to create a full datetime string
      const fullDateTime = `${item.date}T${item.time}`;
      return [
        new Date(fullDateTime).getTime(),
        parseFloat(item.current_balance),
      ];
    });

    return array;
  };
  const dataPoints = [
    {
      name: "Balance Fluctuation", // Name for the legend
      data: graphData,
    },
  ];
  const options = {
    chart: {
      id: "area-datetime",
      type: "area",
      height: 350,
      zoom: {
        autoScaleYaxis: true,
      },
      toolbar: {
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 0,
      colors: ["#47B971"],
    },
    markers: {
      size: 0,
      style: "hollow",
      colors: ["#88bce9"],
      hover: {
        size: 6,
        colors: ["#88bc39"],
      },
    },

    plotOptions: {
      area: {
        colors: ["#88bce9"],
      },
      dataLabels: {
        enabled: false,
      },
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return `₹${value.toFixed(2)}`;
        },
      },
      min: 0,
    },
    grid: {
      show: false, // Disable horizontal and vertical grid lines
    },
    tooltip: {
      color: "#88bce9",

      x: {
        enabled: false,
        format: "dd MMM yyyy HH:mm",
      },
      y: {
        formatter: function (value) {
          return `₹${value.toFixed(2)}`;
        },
        title: {
          formatter: function () {
            return "Balance";
          },
        },
      },
      marker: {
        fillColors: ["#88bce9"],
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 100],
        colorStops: [
          { offset: 0, color: "#88bce9", opacity: 0.9 },
          { offset: 100, color: "#88bce9", opacity: 0.3 },
        ],
      },
    },
    legend: {
      showForSingleSeries: true,

      show: true, // Ensure this is true
      position: "bottom", // You can change position to 'bottom', 'left', 'right' as needed
      horizontalAlign: "center",
      offsetY: 12,
      markers: {
        shape: "square", // Change legend marker to square
        radius: 8, // Set radius to 0 to avoid rounded corners
        size: 8, // Adjust size of the square marker
      },
    },
  };

  function capitalizeFirstLetter(str) {
    if (!str || str === undefined) return ""; // Handle empty or undefined string

    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  function capitalizeWords(str) {
    return str
      .split(" ") // Split the string into an array of words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(" "); // Join the words back into a single string
  }

  useEffect(() => {
    setGraphData(mapData(data ? data[filter.value]?.balance_graph_data : []));
    setBadgeData(data ? data[filter.value]?.balance_fluctuation : []);
  }, [filter, data]);

  return (
    <div className="mt-6 border-[#e6ebed] border rounded-lg ">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Balance Fluctuation </p>
      </div>

      <div className=" flex">
        <div className="mt-8 w-[55%]">
          <div className=" pl-4 pr-2 w-full flex items-center justify-between">
            <p className=" text-xs font-bold">Balance Chart</p>
            <DropdownFilter filterValue={filter} setFilterValue={setFilter} />
          </div>
          <div>
            <Chart
              options={options}
              series={dataPoints}
              type="area"
              height={350}
            />
          </div>
        </div>
        <div className="ml-14 pt-2 w-[45%] pb-1">
          {badgeData.map((data, index) => (
            <div
              key={index}
              className=" w-[75%] min-h-[43px] py-1 px-2 bg-[#e9f5ff] mt-2"
            >
              <p className=" w-full text-xs font-bold flex items-center justify-between">
                <span>{capitalizeWords(data?.title)}</span>
                <span>
                  {data.remark !== "count" && "₹"}
                  {String(data.value)}
                </span>
              </p>
              <p className=" mt-[2px] text-xs font-medium">
                {capitalizeFirstLetter(data?.remark)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BalanceFluctuation;
